import { render } from "./AddDependentView.vue?vue&type=template&id=4d62be30&ts=true"
import script from "./AddDependentView.vue?vue&type=script&lang=ts"
export * from "./AddDependentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__